import { createContext, useState, useContext } from "react";

// Create Context
const FormContext = createContext();

// Custom Hook to Use Context
export const useFormContext = () => useContext(FormContext);

// Provider Component
export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState([]);

  return (
    <FormContext.Provider value={{ formData, setFormData }}>
      {children}
    </FormContext.Provider>
  );
};
